<template>
  <div class="m-wap-qrcode cf" v-show="!isFrozen">
    <!-- 报名图标 -->
    <div
      class="qrcode-item-container fl"
      v-if="extras.signUpIcon.display === 1"
      v-show="(signUpQrCodeState && !memberInfo.signUpId) || isSetting == 1"
      @click="showBox('signup')"
    >
      <img
        class="qrcode-item-image"
        v-if="extras.signUpIcon.display === 1"
        :src="extras && extras.signUpIcon && extras.signUpIcon.src"
        alt="立即报名"
      />
    </div>
    <!-- 签到码图标 -->
    <div
      class="qrcode-item-container fl"
      v-if="extras.imgQrCode.display === 1"
      v-show="memberInfo.qrCode || isSetting == 1"
      @click="showBox('qrcode')"
    >
      <img
        class="qrcode-item-image"
        v-if="extras.imgQrCode.display === 1"
        :src="extras && extras.imgQrCode && extras.imgQrCode.src"
        alt="微信"
      />
      <div class="qrcode-item" v-show="isShowBox === 'qrcode'">
        <div class="qrcode-close-container" @click.stop="closeBox"></div>
        <div class="qrcode-item-title text-center">报名成功，期待您的莅临</div>
        <div class="qrcode-item-qrcode">
          <div id="j-qrcode"></div>
        </div>
        <div class="qrcode-item-id text-center">
          参会人ID：{{ memberInfo.signUpId }}
        </div>
        <div class="qrcode-item-tips text-center">现场需要向主办方出示</div>
      </div>
    </div>
    <!-- 分享图标 -->
    <div
      v-if="extras.imgShare.display === 1"
      v-show="sharePosterUrl || isSetting == 1"
      class="qrcode-item-container fl"
      @click="showBox('share')"
    >
      <img
        class="qrcode-item-image"
        v-if="extras.imgShare.display === 1"
        :src="extras && extras.imgShare && extras.imgShare.src"
        alt="分享"
      />
    </div>

    <div
      v-if="extras.imgWeChat.display === 1"
      v-show="seminarInfo.weChatType === 'custom' || isSetting == 1"
      class="qrcode-item-container fl"
      @click="showBox('wechat')"
    >
      <img
        class="qrcode-item-image"
        :class="{
          'cursor-default': isSetting == 1,
        }"
        v-if="extras.imgWeChat.display === 1"
        :src="extras && extras.imgWeChat && extras.imgWeChat.src"
        alt="微信"
      />
      <div
        class="qrcode-item qrcode-item-wechat"
        v-show="isShowBox === 'wechat'"
      >
        <div class="qrcode-close-container" @click.stop="closeBox"></div>
        <div class="qrcode-item-title text-center">长按识别二维码</div>
        <div class="qrcode-item-qrcode">
          <img
            class="qrcode-item-qrcode-image"
            :src="seminarInfo.weChatQrCodeUrl"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { URLS } from "fire-wind-water/index";
import { userModel } from "../../mixins/user";
import { sdeModel } from "../../mixins/sde";
import { posterModel } from "../../mixins/poster";
import { goto } from "../../mixins/goto";

export default {
  props: {
    seminarInfo: Object,
    memberInfo: Object,
    extras: Object,
    markCode: String,
    signUpStatus: Number,
    isFrozen: Boolean,
  },
  data() {
    return {
      isLogin: false,
      isSetting: 0,
      signUpQrCodeState: false,
      signUpWap: "",
      isShowBox: "",
      sharePosterUrl: "",
      qrcodeList: [],
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  watch: {
    "memberInfo.qrCode"(val) {
      if (val) {
        this.setQrcode("j-qrcode", this.memberInfo.qrCode);
      }
    },
  },
  mounted() {
    userModel.user.module(this);
    sdeModel.seminar.module(this);
    const info = window.$sk.template.get();
    const smarketMember = info.cookie.getSession();
    this.isLogin = !!smarketMember;
    if (this.memberInfo.qrCode) {
      this.setQrcode("j-qrcode", this.memberInfo.qrCode);
    }
  },
  methods: {
    skSeminarEnd(res) {
      if (res.signUpWap && res.status !== "completed") {
        this.signUpQrCodeState = true;
      }
    },
    skSeminarUserEnd() {
      posterModel.poster.module(this);
    },
    skPosterEnd() {
      setTimeout(() => {
        this.sharePosterUrl = goto.poster(true);
        console.log(this.sharePosterUrl);
      }, 100);
    },

    showBox(e) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      if (e === "signup") {
        goto.signUp();
        return;
      }
      if (e === "share") {
        goto.poster();
        return;
      }
      this.isShowBox = e;
    },
    closeBox() {
      this.isShowBox = "";
    },
    clearSession() {
      this.sharePosterUrl = "";
    },
    setQrcode(domId, text) {
      if (this.qrcodeList.indexOf(domId) < 0) {
        this.qrcodeList.push(domId);
        new QRCode(domId, {
          width: 158,
          height: 158,
          text,
          colorDark: "#000",
          colorLight: "#fff",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
